module.exports = __webpack_public_path__ + "img/boxes-front.935bed0e.png";